
<gmap-autocomplete @place_changed="setAddresses" @keydown.enter.prevent @input.prevent="setContent">
  <template #default="slotProps">
    <TextField
      :id="id"
      ref="input"
      v-model="content"
      :labelName="labelName"
      :name="name"
      :type="'text'"
      :status="status"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :readonly="readonly"
      :maxlength="maxlength"
      :helperText="helperText"
      :iconStatic="iconStatic"
      refName="input"
      @listeners="slotProps.listeners"
      @attrs="slotProps.attrs"
      @blur="$emit('blur')"
    />
  </template>
</gmap-autocomplete>
